import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { ICountry } from "../../models/BaseModel";

export interface IOpenForm {
    open: boolean,
    singleData: ICountry
}

export const Country = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    return (
        <>
            {(hasPermission("Country", "Add") || hasPermission("Country", "Edit")) && <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
